const adminRoutes = [
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    component: () => import('@/views/Layouts/SidebarContent'),
    meta: {
      allowedUserTypes: ['superuser']
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/AdminPanel/Dashboard/'),
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'profil',
        component: () => import('@/views/AdminPanel/Settings/Profile/'),
        meta: {
          title: 'Mój profil'
        }
      },
      {
        path: 'rozliczenia-kursantow',
        component: () => import('@/views/AdminPanel/CoursePayments/'),
        meta: {
          title: 'Rozliczenia kursantów'
        }
      },
      {
        path: 'lektorzy',
        component: () => import('@/views/AdminPanel/Lecturer/List/'),
        meta: {
          title: 'Lista lektorów'
        }
      },
      {
        path: 'dodaj-lektora',
        component: () => import('@/views/AdminPanel/Lecturer/Create/'),
        meta: {
          title: 'Dodaj lektora'
        }
      },
      {
        path: 'lektorzy/szczegoly/:lecturerId',
        component: () => import('@/views/AdminPanel/Lecturer/Details/'),
        children: [
          {
            path: 'edytuj',
            component: () =>
              import('@/views/AdminPanel/Lecturer/Details/Edit/'),
            meta: {
              title: 'Edytuj lektora'
            }
          },
          {
            path: 'kalendarz',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Lecturer/Details/Calendar/'),
            meta: {
              title: 'Kalendarz lektora'
            }
          },
          {
            path: 'kursy',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Lecturer/Details/Courses/'),
            meta: {
              title: 'Kursy lektora'
            }
          },
          {
            path: 'aplikacje',
            component: () =>
              import('@/views/AdminPanel/Lecturer/Details/Applications/'),
            meta: {
              title: 'Aplikacje lektora'
            }
          },
          // {
          //   path: 'rozliczenia',
          //   component: () =>
          //     import('@/views/AdminPanel/Lecturer/Details/Payments/'),
          //   meta: {
          //     title: 'Rozliczenia i umowy'
          //   }
          // },
          {
            path: 'notatki',
            component: () =>
              import('@/views/AdminPanel/Lecturer/Details/Notes/'),
            meta: {
              title: 'Notatki lektora'
            }
          }
        ]
      },
      {
        path: 'kursanci',
        component: () => import('@/views/AdminPanel/Student/List/'),
        meta: {
          title: 'Lista kursantów'
        }
      },
      {
        path: 'dodaj-kursanta',
        component: () => import('@/views/AdminPanel/Student/Create/'),
        meta: {
          title: 'Dodaj kursanta'
        }
      },
      {
        path: 'kursanci/szczegoly/:studentId',
        component: () => import('@/views/AdminPanel/Student/Details/'),
        children: [
          {
            path: 'edytuj',
            component: () => import('@/views/AdminPanel/Student/Details/Edit/'),
            meta: {
              title: 'Edytuj kursanta'
            }
          },
          {
            path: 'kalendarz',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Student/Details/Calendar/'),
            meta: {
              title: 'Kalendarz kursanta'
            }
          },
          {
            path: 'kursy',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Student/Details/Courses/'),
            meta: {
              title: 'Lista kursów kursanta'
            }
          },
          {
            path: 'aplikacje',
            component: () =>
              import('@/views/AdminPanel/Student/Details/Applications/'),
            meta: {
              title: 'Aplikacje kursanta'
            }
          },
          {
            path: 'rozliczenia',
            component: () =>
              import('@/views/AdminPanel/Student/Details/Payments/'),
            meta: {
              title: 'Rozliczenia i umowy'
            }
          },
          {
            path: 'notatki',
            component: () =>
              import('@/views/AdminPanel/Student/Details/Notes/'),
            meta: {
              title: 'Notatki kursanta'
            }
          }
        ]
      },
      {
        path: 'kursy',
        component: () => import('@/views/AdminPanel/Course/List/'),
        meta: {
          title: 'Lista kursów'
        }
      },
      {
        path: 'dodaj-kurs',
        component: () => import('@/views/AdminPanel/Course/Create/'),
        meta: {
          title: 'Dodaj kurs'
        }
      },
      {
        path: 'kursy/szczegoly/:courseId',
        component: () => import('@/views/AdminPanel/Course/Details/'),
        children: [
          {
            path: 'edytuj',
            component: () => import('@/views/AdminPanel/Course/Details/Edit/'),
            meta: {
              title: 'Edytuj kurs'
            }
          },
          {
            path: 'kalendarz',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Course/Details/Calendar/'),
            meta: {
              title: 'Kalendarz kursu'
            }
          },
          {
            path: 'lektor',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Course/Details/Lecturer/'),
            meta: {
              title: 'Szczegóły lektora'
            }
          },
          {
            path: 'materialy-dydaktyczne',
            component: () =>
              import('@/views/AdminPanel/Course/Details/Materials/'),
            props: true,
            meta: {
              title: 'Materiały dydaktyczne'
            }
          },
          {
            path: 'historia-zajec',
            component: () =>
              import('@/views/AdminPanel/Course/Details/History/'),
            props: true,
            meta: {
              title: 'Historia zajęć'
            }
          }
        ]
      },
      {
        path: 'biblioteka',
        component: () => import('@/views/AdminPanel/Library/'),
        children: [
          {
            path: 'kursy',
            component: () =>
              import('@/views/AdminPanel/Library/ForCoursesTab/'),
            meta: {
              title: 'Biblioteka dla kursów'
            }
          },
          {
            path: 'lektorzy',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Library/ForLecturersTab/'),
            meta: {
              title: 'Biblioteka dla lektorów'
            }
          },
          {
            path: 'kursanci',
            props: true,
            component: () =>
              import('@/views/AdminPanel/Library/ForStudentsTab/'),
            meta: {
              title: 'Biblioteka dla kursantów'
            }
          }
        ]
      }
    ]
  }
]

export default adminRoutes
